import React, { useEffect, useRef, useState } from 'react';

const SingleCheck = ({ objKey, options, defValue, onChange }) => {
  const [checkedItem, setCheckedItem] = useState(null)
  const checksRef = useRef(null)

  const handleCheckboxChange = (value) => {
    setCheckedItem(value)
    setSelected(value)
    if(onChange){
      onChange(value, objKey)
    } 
  }

  const setValue = (option) => {
    handleCheckboxChange(parseInt(option))
  }

  const setSelected = (value) => {
    let checkedInput = checksRef.current.querySelector(`input[value="${value}"]`)
    let wrappers = checksRef.current.querySelectorAll('.multi-check-item')
    for(let w of wrappers) {
      w.classList.remove('selected')
    }

    if(checkedInput?.parentNode) {
      checkedInput.parentNode.classList.add('selected')
    } else {
      wrappers[0].classList.add('selected')
    }    
  }

  useEffect(() => {
    if(defValue) {
      setValue(defValue)
    }
  }, [])

  return (
    <div ref={checksRef} className="multi-check-container">
      {options.map(option => (
        <div key={option.id} className="multi-check-item">
          <input
            type="radio"
            id={option.id}
            value={option.id}
            title={option.title}
            checked={checkedItem === option.id}
            onChange={() => handleCheckboxChange(option.id)}
            hidden={true}
          />
          <label htmlFor={option.id} className="multi-check-label">{option.label}</label>
        </div>
      ))}
    </div>
  )
}

export default SingleCheck
